/**
 * @summary     ui.liveFieldCalculation
 * @description Live on-change calculations for fields within the form
 * @version     1.1
	> 1.0 Initial version
		- 01/25/15 Ian Juarez
 * @file        app.ui.liveFieldCalculation.js
 * @author      Ian Juarez
 ** Examples:
 ** NOTE:   Copied from Admin Portal repo - 02/16/22 Chris Hughes
 ** TODO:
*/

app.ui.addFeature("liveFieldCalculation",
	function () {
		this.self = this;
		this.formMeta = {};
		this.settings = {};

		/*
			Name: Constructor
			Args: settings (Object) - Calculation field settings
				formMeta (Array of objects) - Array of all other field settings.
		*/
		this.init = function (settings, formMeta) {

			var metaset = 'entryForm';
			self.settings = settings;

			// somehow this wasn't actually being instantiated above, so I'm doing it here.
			self.formMeta = (self.formMeta || {});

			if (settings.calcs && settings.calcs.type === "live") {

				/*
					Note: 
						2021-03-12 KK
						This is a fix to handle a bug found during mon-1109459363 in which a liveCalc in a Reload
						would overwrite the formMeta of the parent Entry page. To support both, the meta information
						is now all saved with keys to the different meta sets.
				*/
				if ((settings.calcs.target.src || '').startsWith('Reload_')) {
					metaset = settings.calcs.target.src.slice(7);
					self.formMeta[metaset] = formMeta;
				} else {
					self.formMeta.entryForm = formMeta;
				}

				settings.calcs.inputs.forEach(function (input) {

					//Set on-change events
					app.events.on('ui.' + input.field, function (eventData) {
						var oldValue = $("#" + settings.calcs.target.field).val();
						var inputValues = {};
						var calcString = "";
						var targetValue = "";

						settings.calcs.inputs.forEach(async function (input) {
							var fieldMeta = self.formMeta[metaset].find(function (field) {
								return field.properties.id === input.field;
							});

							if (typeof fieldMeta !== 'undefined') {
								if (fieldMeta.type === "reload") {
									/*
										NOTE:
											Was using this:
											inputValues[input.label] = getReloadValue(input, eventData.newValue);

											However, this does not work if a calculation involves more than just
											the current reload being updated...ie multiple reloads
									*/
									// get the reload values of the current input
									var reloadValues = $(`#${input.field}_values`)[0] ? $(`#${input.field}_values`)[0].value : '[]';
									reloadValues = JSON.safeParse(reloadValues, []);
									inputValues[input.label] = getReloadValue(input, {
										DATA: reloadValues
									});
								} else if (fieldMeta.type === "checklist-control") {
									/*
									    NOTE: 
									        Checklist Control, currently not supported in Myhd form entry
									*/
									// inputValues[input.label] = getChecklistValue(input, eventData);
								} else {
									inputValues[input.label] = getInputValue(input.field);
								}
							} else {
								console.log('Error: ' + eventData.id + ' logic skipped, field not found in metaSet ' + metaset + '.');
							}
						});

						calcString = settings.calcs.output.compile(inputValues);

						try {
							calcString = calcString.replace(/ceiling/ig, 'Math.ceil');

							targetValue = eval(calcString);

							if (targetValue != oldValue && (targetValue === 0 || targetValue)) {

								// If a live calculation updates, it needs to trigger a change event
								// We need to trigger an input event so Vue will update.
								$("#" + settings.calcs.target.field).val(targetValue)[0].dispatchEvent(new Event('input'));


								app.events.emit("formValuesChanged", {
									id: settings.calcs.target.field,
									newValue: targetValue,
									oldValue: oldValue,
									liveFieldCalculation: true
								});
								app.events.emit(
									'ui.' + settings.calcs.target.field, {
										id: settings.calcs.target.field,
										newValue: targetValue,
										oldValue: oldValue,
										liveFieldCalculation: true
									}
								);
							}
						} catch (e) {
							console.log("Invalid calcString");
							app.dataUtils.logSysError(e);
						}
					});
				});
			}

		}

		function getInputValue(fieldID) {
			return $("#" + fieldID).val() || 0;
		}

		function getReloadValue(input, data) {
			var result = "";

			if (typeof data === 'object' && 'DATA' in data) {
				var filteredData = data.DATA.filter(function (row) {
					if (input.filterColumn && input.filterValue) {
						return (row[input.filterColumn] == input.filterValue);
					} else {
						return true;
					}
				});

				switch (input.operation) {
					case "SUM":
						result = filteredData.reduce(function (accumulator, row) {
							return accumulator + parseFloat(row[input.fieldColumn]);
						}, 0);
						break;
					case "COUNT":
						result = filteredData.length;
						break;
				}

			}

			return result;
		}

		/*
		    NOTE: 
		        Checklist Control, currently not supported in Myhd form entry
		*/
		function getChecklistValue(input, eventData) {
			var result = "";
			var checklistObj = eventData.newValue;

			if (typeof checklistObj === 'object' && 'vioMap' in checklistObj) {
				var filteredData = Object.keys(checklistObj.vioMap).filter(function (vioID) {
					if (input.filterColumn && input.filterValue) {
						return (checklistObj.vioMap[vioID][input.filterColumn] == input.filterValue);
					} else {
						return true;
					}
				});

				switch (input.operation) {
					case "SUM":
						result = filteredData.reduce(function (accumulator, vioID) {
							return accumulator + parseFloat(checklistObj.vioMap[vioID][input.fieldColumn]);
						}, 0);
						break;
					case "COUNT":
						result = filteredData.length;
						break;
				}
			}

			return result;
		}

		return this.init;
	}
);